module.exports = __webpack_public_path__ + "img/灰泡泡球_0044.b31917f2.png";